import { useMemo } from 'react';

import {
  useResourceFilters,
  useResourceFilterOptions,
  ResourceManagerFilterState,
} from './use-resource-filters';

interface ResourceFacets {
  skillCategories?: Array<{
    id: string;
    title: string;
  }>;
  mediaTypes?: Array<{
    id: string;
    title: string;
  }>;
  locations?: Array<{
    id: string;
    title: string;
  }>;
}

const initialResourceManagerFilters: ResourceManagerFilterState = {
  mediaTypes: [],
  skillCategoryIds: [],
  status: [],
  searchQuery: '',
  updatedFrom: undefined,
  updatedTo: undefined,
};

const statusOptions = [
  {
    label: 'Archived',
    value: 'archived',
  },
  {
    label: 'Draft',
    value: 'draft',
  },
  {
    label: 'Published',
    value: 'published',
  },
];

export function useResourceManagerFilters(
  facets?: ResourceFacets,
  valueType: 'id' | 'title' = 'title'
) {
  const filterHook = useResourceFilters({
    initialFilters: initialResourceManagerFilters,
    debounceDelay: 500,
  });

  const filterOptions = useResourceFilterOptions(facets, valueType);

  const resourceParams = useMemo(
    () => ({
      pageNumber: filterHook.currentPage,
      pageSize: 10, // Resource manager uses 10 items per page
      searchQuery: filterHook.debouncedFilters.searchQuery,
      skillCategories: filterHook.debouncedFilters.skillCategoryIds.join(','),
      mediaTypes: filterHook.debouncedFilters.mediaTypes.join(','),
      status: filterHook.debouncedFilters.status.join(','),
      updatedFrom: filterHook.debouncedFilters.updatedFrom,
      updatedTo: filterHook.debouncedFilters.updatedTo,
    }),
    [filterHook.currentPage, filterHook.debouncedFilters]
  );

  return {
    ...filterHook,
    ...filterOptions,
    statusOptions,
    resourceParams,
  };
}
